<template>
  <div class="selection-summary">
    <div class="selections">
      <span class="student-info">Student information:</span>
      <div class="selections-list">
        <span
          v-for="item in summaryItems"
          class="summary-item"
          :key="`section-summary-item-${htmlIDFromString(item)}`">
          {{ item }}
        </span>
      </div>
    </div>
    <button
      class="btn btn-primary start-over"
      @click="$emit('reset')">
      Start Over
    </button>
  </div>
</template>

<script>
import { htmlIDFromString } from '@/util/html_utils'

export default {
  name: 'CharacteristicsSummary',
  methods: { htmlIDFromString },
  props: {
    summaryItems: {
      type: Array,
      default() {
        return []
      }
    }
  }
}
</script>

<style scoped lang='less'>
@import "~@/variables.less";
.selection-summary {
  width: 100%;
  font-size: 0.875rem;
  line-height: 2.5rem;
  margin-top: 1rem;

  .selections {
    display: grid;
    grid-template-columns: auto 1fr;

    .student-info {
      margin-right: 0.75rem;
    }

    .selections-list {
      .summary-item {
        background: rgba(224, 245, 255, 0.50);
        padding: 0.5rem 1.5rem;
        border-radius: 0.5rem;
        margin-right: 0.5rem;
        margin-bottom: 0.5rem;
        display: inline-block;
        line-height: 1.25rem;
      }
    }
  }

  .start-over {
    color: white;
    padding: var(--spacing-md) var(--spacing-xl);
    border-radius: var(--radius-base);
    background: var(--blue-default);
    margin-top: 0.5rem;

    &:hover, &:active {
      border-radius: var(--radius-base);
      background: var(--blue-hover);
    }

    &:active, &:focus {
      outline: 0.15rem solid var(--blue-hover);
      outline-offset: 0.15rem;
    }
  }
}
</style>
